module.exports = __webpack_public_path__ + "b48db8f3.png";